import NumberPickers from './../../modules/number-picker'

const noticeMaxClass = 'visitors-selector-notice--alert'

let selector      = null
let notice        = null
let maxVisitors   = null
let totalVisitors = 0
let counter       = null

const init = () => {

	// Initialise number pickers
	NumberPickers()

	selector    = document.querySelector('[data-visitors-selector]');
	notice      = selector.querySelector('[data-visitors-selector-notice]');
	maxVisitors = parseInt(selector.getAttribute('data-visitors-selector-max'));
	counter     = selector.querySelector('[data-visitor-count]');

	// Listen for when any number picker changed
	selector.addEventListener('number-picker-changed', (e) => {

		// Reset total visitors num
		totalVisitors = 0

		console.log('number picker changed')

		// Loop through all visitor options in selector
		for (const item of selector.querySelectorAll('[data-visitor-option]')) {

			// Get number of visitors each selection is equivalent to for this visitor type
			const numPerSelection = parseInt(item.getAttribute('data-visitor-option-num-per-selection'))
			// Get field containing current number of visitor type
			const pickerFld = item.querySelector('[data-number-picker-field]')

			console.log('Num per selection', numPerSelection)
			console.log('Number of tickets', parseInt(pickerFld.value))

			// Increase total visitors by (field value * number of visitors per selection)
			totalVisitors += (parseInt(pickerFld.value) * numPerSelection)

			console.log('Total Visitors', totalVisitors)
		}

		// Display total selected visitors on page
		counter.innerHTML = totalVisitors;

		// Highlight visitor notice if max visitors selected
		if (totalVisitors === maxVisitors) {
			notice.classList.add(noticeMaxClass)
		} else {
			notice.classList.remove(noticeMaxClass)
		}

		// Loop through visitor types to determine if increase btns need to be disabled based on current selected visitors
		for (const item of document.querySelectorAll('[data-visitor-option]')) {
			
			// Get number of visitors each selection is equivalent to for this visitor type
			const numPerSelection = parseInt(item.getAttribute('data-visitor-option-num-per-selection'))
			// Get increase btn
			const incBtn = item.querySelector('[data-number-picker-increase]')

			// If an increase on this option would push total visitors over max allowed, disable increase button
			if ( (totalVisitors + numPerSelection) > maxVisitors) {
				incBtn.disabled = true;
			} else {
				incBtn.disabled = false;
			}
		}

		// Dispatch event to show current step validity
		const ev = new CustomEvent('step-validity-change', {
			bubbles: true,
			detail: (totalVisitors > 0) ? true : false
		})
		selector.dispatchEvent(ev)
	})
}

export default function() {
    init();
}